export default class Impfempfehlung {
    public impfempfehlung_id: number | null = null;
    public impfempfehlung: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Impfempfehlung>) {
        Object.assign(this, data);
    }
}
